"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fontPloni = require("../font.ploni.config");
var _helpers = require("../../components/utils/helpers");
var AlertIcon = (0, _helpers.getImageByAgent)('alert.svg');
var ErrorIcon = (0, _helpers.getImageByAgent)('error.svg');
var InfoIcon = (0, _helpers.getImageByAgent)('info.svg');
var SuccessIcon = (0, _helpers.getImageByAgent)('success.svg');
var _default = function _default(isFontBigger, isHighContrast) {
  return {
    root: {
      '& .MuiSnackbarContent-message': {
        '&:before': {
          backgroundClip: 'padding-box',
          backgroundImage: "url(".concat(AlertIcon, ")"),
          backgroundPosition: 'center left',
          backgroundRepeat: 'no-repeat',
          content: '""',
          display: 'inline-flex',
          height: 20,
          paddingLeft: '30px',
          width: 20
        },
        alignItems: 'center',
        display: 'inline-flex',
        padding: '9px 0'
      },
      '&.icon-error': {
        '& .MuiSnackbarContent-message': {
          '&:before': {
            backgroundImage: "url(".concat(ErrorIcon, ")")
          }
        }
      },
      '&.icon-info': {
        '& .MuiSnackbarContent-message': {
          '&:before': {
            backgroundImage: "url(".concat(InfoIcon, ")")
          }
        }
      },
      '&.icon-success': {
        '& .MuiSnackbarContent-message': {
          '&:before': {
            backgroundImage: "url(".concat(SuccessIcon, ")")
          }
        }
      },
      '&.icon-warning': {
        '& .MuiSnackbarContent-message': {
          '&:before': {
            backgroundImage: "url(".concat(AlertIcon, ")")
          }
        }
      },
      alignItems: 'center',
      backgroundColor: isHighContrast ? 'rgba(0,0,255,.1)' : _helpers.agentDeveloperUtils.getConvertedColor('#D6EEF5'),
      border: '1px solid #D6EEF5',
      borderRadius: 20,
      boxShadow: '0px 2px 3px #0000000A',
      color: isHighContrast ? '#fff' : _helpers.agentDeveloperUtils.getSecondaryColor(300),
      display: 'flex',
      fontFamily: _fontPloni.PloniRegular,
      fontSize: isFontBigger ? '20px' : '16px',
      justifyContent: 'space-between',
      lineHeight: '24px',
      maxWidth: 'fit-content',
      opacity: 1,
      padding: '0 25px 0 15px',
      width: 'max-content'
    }
  };
};
exports.default = _default;